module.exports = __webpack_public_path__ + "static/media/tgicon.3bb79210.png";